import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import {
  EmailNotificationsConfiguration,
  NotificationConfigurationResponse,
} from './getNotificationConfiguration';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const saveNotificationConfiguration: MutationFunction<
  boolean,
  EmailNotificationsConfiguration
> = async (args) => {
  if (isMockServices()) return (await mock(_mockType)).success;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<NotificationConfigurationResponse>(
    `/configurations/EmailNotifications`,
    {
      method: 'POST',
      body: {
        configuration: args,
      },
    },
  );
  if (response.data) return response.data.success;

  throw new Error('Failed to update notification status');
};

export default saveNotificationConfiguration;

const _mockType = {
  success: true,
};
